import {
  USERS_BOOKSHELF_DETAIL_SET_DATA,
  USERS_BOOKSHELF_DETAIL_RESET_DATA,
} from 'rebook/apps/users/constants';


const initialState = {
  userId: null,
  bookshelfId: null,
  bookshelf: null,
  books: null,
  paginateBy: 24,
  pageNumber: 1,
  lastPageNumber: 0,
  subscriptionId: null,
  bookType: null,
};

export default function userBookshelfDetail(state = initialState, action) {
  switch (action.type) {
    case USERS_BOOKSHELF_DETAIL_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case USERS_BOOKSHELF_DETAIL_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
